import { Abstrap } from '..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'form' };

class Form extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-form',
            className,
        ];
    }

}

Form.propTypes = propTypes;

Form.defaultProps = defaultProps;

export default Form;
